import React, { ReactNode } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { formatCurrencyString } from 'src/utils/currency';
import { Box } from '@mui/material';

const SubAndTotalRow = ({
  value,
  currency,
  desc,
  isTotal,
  customNaNMessage,
  children
}: {
  value: number;
  currency: string;
  desc: string;
  isTotal: boolean;
  customNaNMessage?: string;
  children?: ReactNode;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      className={isTotal ? 'total' : 'subtotal'}
      sx={{
        margin: isMobile ? '.5rem 0' : '1rem 0',
        textAlign: 'right',
        color: '#444444',
        fontSize: '1.2rem',
        display: 'flex',
        justifyContent: 'flex-end',
        fontFamily:
          '-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji"'
      }}
    >
      {children}
      <Box className="desc" sx={{ display: 'inline', marginRight: '2rem' }}>
        {desc}
      </Box>
      <Box
        id={`${isTotal ? 'cart-total' : 'row-total'}`}
        sx={{
          display: 'inline',
          color: '#0b5466',
          fontSize: '1.3rem !important'
        }}
      >
        {isNaN(value)
          ? customNaNMessage
            ? customNaNMessage
            : '-'
          : formatCurrencyString({
              value,
              currency: currency.toUpperCase()
            })}
        {isTotal ? ` ${currency.toUpperCase()}` : ''}
      </Box>
    </Box>
  );
};

export default SubAndTotalRow;
